import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import some from 'lodash/some';

export const hasNonEmpty = (obj: unknown, keys: string[]): boolean =>
  some(map(keys, (key: string) => !isEmpty(get(obj, key))));
